module.exports = "images/location_atm.eff26c2d6359e5f0ee3ab55e7c59e764.png";